/** On/off switch for a setting that is simply yes or no. */
export default function SettingToggle({ label, hint, note, checked, onChange, disabled }) {
    return (
        <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
                <div className="text-[13.5px] font-semibold text-[#1C1815] dark:text-zinc-100">{label}</div>
                <div className="text-[11.5px] leading-snug text-[#A8A099] dark:text-zinc-500">{hint}</div>
                {note ? <div className="text-[11px] leading-snug text-amber-600 dark:text-amber-400">{note}</div> : null}
            </div>
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                aria-label={label}
                onClick={() => onChange(!checked)}
                disabled={disabled}
                className={`relative h-6 w-11 flex-none rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-45 ${
                    checked ? 'bg-primary' : 'bg-[#D6D6DE] dark:bg-zinc-600'
                }`}
            >
                <span
                    className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all ${checked ? 'left-[22px]' : 'left-0.5'}`}
                />
            </button>
        </div>
    );
}
